import React__default from 'react';
import { Icon } from '../../../Icon/Icon.js';
import { actions } from 'react-table';
import { sanitizeRowProps } from '../../util.js';

const pluginName = 'useRowDraggable';
actions.resetRowDragging = 'resetRowDragging';
actions.toggleRowDragging = 'toggleRowDragging';

function reducer(state, action) {
  if (action.type === actions.init) {
    return {
      draggingRowIndexPath: null,
      ...state
    };
  }

  if (action.type === actions.resetRowDragging) {
    return { ...state,
      draggingRowIndexPath: null
    };
  }

  if (action.type === actions.toggleRowDragging) {
    const {
      indexPath
    } = action;
    return { ...state,
      draggingRowIndexPath: indexPath
    };
  }

  return state;
}

const prepareRow = (row, {
  instance
}) => {
  row.toggleRowDragging = () => {
    if (instance.state.draggingRowIndexPath === row.id) {
      instance.dispatch({
        type: actions.resetRowDragging
      });
    } else {
      instance.dispatch({
        type: actions.toggleRowDragging,
        indexPath: row.id
      });
    }
  };

  if (instance.state.draggingRowIndexPath) {
    var _instance$state$selec;

    row.isDragging = instance.state.draggingRowIndexPath === row.id || !!((_instance$state$selec = instance.state.selectedRowIds) !== null && _instance$state$selec !== void 0 && _instance$state$selec[row.id]);
  } else {
    row.isDragging = false;
  }
};

const visibleColumns = columns => {
  return [{
    id: 'draggable',
    className: 'yt-table__cell--draggable flex-col px-0',
    Cell: () => React__default.createElement(Icon, {
      name: "drag",
      className: "text-grey-darkest invisible w-[20px] cursor-grab"
    }),
    flex: '0 0 20px'
  }, ...columns];
};

const getRowProps = onRowDrag => (props, {
  instance,
  row
}) => {
  const onDragStart = event => {
    event.persist();
    row.toggleRowDragging();
    const indexPaths = [row.id, ...Object.keys(instance.state.selectedRowIds)];
    const data = instance.rows.filter(r => indexPaths.includes(r.id)).map(sanitizeRowProps);

    const showPlaceholder = placeholder => {
      const element = window.document.createElement('div');
      element.id = 'yt-table__drag__placeholder';
      element.innerText = placeholder;
      window.document.body.appendChild(element);

      if (typeof DataTransfer.prototype.setDragImage === 'function') {
        event.dataTransfer.setDragImage(element, 0, 20);
      }
    };

    onRowDrag(data, showPlaceholder, event);
  };

  const onDragEnd = () => {
    const element = document.getElementById('yt-table__drag__placeholder');

    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }

    row.toggleRowDragging();
  };

  return [props, {
    draggable: true,
    onDragStart,
    onDragEnd
  }];
};

const useRowDraggable = onRowDrag => {
  const plugin = hooks => {
    if (onRowDrag) {
      hooks.stateReducers.push(reducer);
      hooks.prepareRow.push(prepareRow);
      hooks.visibleColumns.push(visibleColumns);
      hooks.getRowProps.push(getRowProps(onRowDrag));
    }
  };

  plugin.pluginName = pluginName;
  return plugin;
};

export { useRowDraggable };
//# sourceMappingURL=useRowDraggable.js.map
